// Route Validation Actions
export const ROUTE_ACCESS_REQUEST = 'ROUTE_ACCESS_REQUEST';
export const ROUTE_ACCESS_GRANTED = 'ROUTE_ACCESS_GRANTED';
export const ROUTE_ACCESS_DENIED = 'ROUTE_ACCESS_DENIED';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';
export const REDIRECT_COMPLETED = 'REDIRECT_COMPLETED';
export const CLEAR_ROUTE_ERROR = 'CLEAR_ROUTE_ERROR';

// Action Creators
export const requestRouteAccess = (pathname, navigate) => ({
  type: ROUTE_ACCESS_REQUEST,
  payload: { pathname, navigate }
});

export const grantRouteAccess = (pathname, reason, token = null, timeRemaining = null) => ({
  type: ROUTE_ACCESS_GRANTED,
  payload: { pathname, reason, token, timeRemaining }
});

export const denyRouteAccess = (pathname, reason, error) => ({
  type: ROUTE_ACCESS_DENIED,
  payload: { pathname, reason, error }
});

export const redirectToLogin = (pathname, navigate) => ({
  type: REDIRECT_TO_LOGIN,
  payload: { pathname, navigate }
});

export const redirectCompleted = (redirectedTo, from) => ({
  type: REDIRECT_COMPLETED,
  payload: { redirectedTo, from }
});

export const clearRouteError = () => ({
  type: CLEAR_ROUTE_ERROR
});
